export default class UtilURL{

    static openURLInNewWindow = (url = "") => {

        if (url instanceof URL) {

            window.open(url.toString(), '_blank', 'noopener,noreferrer');

        } else if (typeof url === 'string') {

            window.open(url, '_blank', 'noopener,noreferrer');
        }

    }

    static isURL = (value) => {

        if (value instanceof URL) {

            return value.protocol === "http:" || value.protocol === "https:";

        }

        if (typeof value !== "string") {

            return false;

        }

        try{

            const url = new URL(value);
            return url.protocol === "http:" || url.protocol === "https:";

        }catch{

            return false;

        }

    }

    static isNotURL = (value) =>{

        return !this.isURL(value);

    }

    static toURL = (url ="") => {

        if(this.isNotURL(url)){
            return null;
        }

        try{

            return URL.createObjectURL(url);

        }catch{

            return null;
            
        }

    }

    static getURLFileName = (url = "") => {

        if(this.isNotURL(url)){
            return "InvalidFile.txt";
        }

        try{

            return decodeURIComponent(
                new URL(url).pathname.split("/").pop()
            );

        }catch{
            return null;
        }

    }

    static getURLMime = (url = "") => {

        if(this.isNotURL(url)){
            return "application/octet-stream";
        }

        try{

            const ext = new URL(url).pathname.split(".").pop().toLowerCase();

            const map = {
                pdf: "application/pdf",
                png: "image/png",
                jpg: "image/jpeg",
                jpeg: "image/jpeg",
                json: "application/json",
                txt: "text/plain",
            };

            return map[ext] || "application/octet-stream";

        }catch{

            return "application/octet-stream";

        }

    };

    static mountInvalidFile = (url = "") => {

        const blob = new Blob(
            [`URL inválida ou não processada: ${url}`],
            { type: "text/plain" }
        );

        return new File(
            [blob],
            "InvalidFile.txt",
            {type: blob.type}
        )

    }

    static mountFile = async (url = "") => {

        if(this.isNotURL(url)){
            return this.mountInvalidFile(url);
        }

        let response;

        try{

            response = await fetch(url);

        }catch{

            return this.mountInvalidFile(url);

        }

        let blob;

        try{

            blob = await response.blob();

        }catch{

            return this.mountInvalidFile(url);

        }

        let fileName = this.getURLFileName(url);
        let fileMime = this.getURLMime(url);

        return new File(
            [blob],
            fileName,
            {
                type: fileMime,
                lastModified: Date.now(),
            },
        )

    }

    static oneToFile = async (url = "") => {

        if(this.isNotURL(url)){
            return this.mountInvalidFile(url);
        } 

        return await this.mountFile(url);

    }

    static manyToFile = async (urls = []) =>{

        const results = [];

        for (const url of urls) {
            const result = await this.oneToFile(url);
            results.push(result);
        }

        return results;

    }

}